module.exports = __webpack_public_path__ + "static/media/circle-cropped.63c1fc9f.png";